module.exports = __webpack_public_path__ + "BD.png?188e1ec8bc42725b147eb63e8fcc1334";